import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import AssetUse from './asset-use';
import AssetUseDetail from './asset-use-detail';
import AssetUseUpdate from './asset-use-update';
import AssetUseDeleteDialog from './asset-use-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={AssetUseUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={AssetUseUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={AssetUseDetail} />
      <ErrorBoundaryRoute path={match.url} component={AssetUse} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={AssetUseDeleteDialog} />
  </>
);

export default Routes;
